const taskRouter = [
    {
        path:'list',
        name:'task-list',
        redirect: { name: 'task-inProgress' },
        component: () => import(/* webpackChunkName: "about" */ '../views/task/list.vue'),
        children:[
            // {
            //     path:'allList',
            //     name:'task-allList',
            //     component: () => import(/* webpackChunkName: "about" */ '../views/task/allTaskList.vue')
            // },
            {
                path:'inProgress',
                name:'task-inProgress',
                component: () => import(/* webpackChunkName: "about" */ '../views/task/inProgress.vue')
            },
            {
                path:'completed',
                name:'task-completed',
                component: () => import(/* webpackChunkName: "about" */ '../views/task/completedList.vue')
            },
            {
                path:'close',
                name:'task-close',
                component: () => import(/* webpackChunkName: "about" */ '../views/task/closeList.vue')
            }
        ],
    },{
        path:'create',
        name:'task-create',
        component: () => import(/* webpackChunkName: "about" */ '../views/task/create.vue'),
    },{
        path:'detail/:id',
        name:'task-detail',
        component: () => import(/* webpackChunkName: "about" */ '../views/task/detail.vue'),
    },{
        path:'edit/:id',
        name:'task-edit',
        component: () => import(/* webpackChunkName: "about" */ '../views/task/edit.vue'),
    }
  ]
  export default taskRouter

  